import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { WebcallbackComponent } from './components/webcallback/webcallback.component';

const routes: Routes = [
    {
      path: 'webcallback',
      component: WebcallbackComponent
    },
    {
      path: '**',
      redirectTo: 'webcallback'
    }
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'top'
    })
  ],
  declarations: [
  ],
  exports: [RouterModule]
})
export class RoutingWCBModule {
}
